<ng-container [formGroup]="form">
	<mat-form-field>
		<input
			autocomplete="off"
			matInput
			placeholder="Offered Service"
			formControlName="name"
			maxlength="100"
			required
		/>
	</mat-form-field>
	<rpshared-service-type
		placeholder="Type"
		formControlName="type"
		required
	></rpshared-service-type>
	<mat-form-field>
		<mat-label>Status</mat-label>
		<mat-select
			required
			disableOptionCentering="true"
			formControlName="isActive"
		>
			<mat-option [value]="true">Active</mat-option>
			<mat-option [value]="false">Inactive</mat-option>
		</mat-select>
		<mat-error>Required</mat-error>
	</mat-form-field>
</ng-container>
